import { BillingMode } from "./changeBillingMode.types";

/** OTP validity window (minutes) sent in the send-otp payload. */
export const OTP_VALID_MINUTES = 60;

/** Resend cooldown for the OTP step (seconds). */
export const OTP_RESEND_SECONDS = 30;

export const BILLING_MODE_LABELS: Record<BillingMode, string> = {
  RECURRING: "Recurring",
  PREPAID: "Prepaid",
};

export const BILLING_MODE_DESCRIPTIONS: Record<BillingMode, string> = {
  RECURRING: "Auto-charged every billing cycle until cancelled.",
  PREPAID: "Pay once upfront for the selected period.",
};

/** Returns the only mode a plan can switch to (the opposite of its current one). */
export const getTargetBillingMode = (current: BillingMode): BillingMode =>
  current === "RECURRING" ? "PREPAID" : "RECURRING";
